export default __webpack_public_path__ + "static/image1-532d68c91d49841770de871099a5ff8d.jpeg";